import React from "react";
import ReportHistory from "../components/reportHistory";
import { useLocation } from "react-router-dom";

const ReportHistoryContainer = () => {
  const location = useLocation();
  const data = location?.state?.row;

  return (
    <>
      <ReportHistory reportData={data} />
    </>
  );
};

export default ReportHistoryContainer;
